import React from 'react';
import { colors } from 'app/shared/theme/colors';
import { useTranslation } from 'app/shared/i18n';

export const Policy = () => {
  const { t } = useTranslation();

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '36px 24px' }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 24, display: 'flex', alignItems: 'center', gap: 10 }}>
        {t('policyPage.title')}
      </h2>
      <div className="ms-card" style={{ padding: 28 }}>
        <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>{t('policyPage.dataWeStore')}</h3>
        {[
          t('policyPage.email'),
          t('policyPage.password'),
          t('policyPage.balance'),
          t('policyPage.depositHistory'),
          t('policyPage.orderHistory'),
        ].map((item, i) => (
          <div key={i} style={{ padding: '8px 0', fontSize: 14, color: colors.muted, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ color: colors.accent }}>•</span>
            {item}
          </div>
        ))}
        <p style={{ fontSize: 14, color: colors.muted, lineHeight: 1.7, marginTop: 16 }}>
          {t('policyPage.deleteAccount')}{' '}
          <a href="https://t.me/mailsngon" target="_blank" rel="noreferrer">
            Telegram
          </a>
          {t('policyPage.deleteDelay')}
        </p>
      </div>
    </div>
  );
};
